import type { SVGProps } from 'react'

/**
 * HappyOps-Logo als Inline-SVG. 1:1 übernommen aus `HappyOpsLogo` in
 * @happy-ops-org/ui-tools — das Paket wird hier bewusst nicht als Abhängigkeit
 * eingebunden, weil es eigene React-/MUI-/Emotion-Kopien bündelt (~2 MB) und
 * eine fremde React-Version pinnt.
 */
export const HappyOpsLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 407.12 408.48"
    {...props}
    style={{ verticalAlign: 'middle', ...props.style }}
  >
    <defs>
      <linearGradient
        id="hops-logo-a"
        x1={-468.3}
        x2={-468.3}
        y1={-667.34}
        y2={-1075.82}
        gradientTransform="matrix(1 0 0 -1 539 -667.34)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#1af8fd" />
        <stop offset={0.6} stopColor="#00b8ff" />
        <stop offset={1} stopColor="#05e2fa" />
      </linearGradient>
      <linearGradient
        id="hops-logo-b"
        x1={-202.58}
        x2={-202.58}
        y1={-667.34}
        y2={-1075.82}
        gradientTransform="matrix(1 0 0 -1 539 -667.34)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fee952" />
        <stop offset={0.47} stopColor="#fda76b" />
        <stop offset={1} stopColor="#ffff47" />
      </linearGradient>
    </defs>
    <path
      d="M70.7 0C31.61 0 0 31.49 0 70.42v267.64c0 38.88 31.61 70.42 70.7 70.42s70.7-31.49 70.7-70.42V70.42C141.34 31.49 109.72 0 70.7 0Z"
      style={{ fill: 'url(#hops-logo-a)' }}
    />
    <path
      d="M336.42 0c-39.03 0-70.7 31.49-70.7 70.42v267.64c0 38.88 31.61 70.42 70.7 70.42s70.7-31.49 70.7-70.42V70.42c0-38.87-31.68-70.42-70.7-70.42Z"
      style={{ fill: 'url(#hops-logo-b)' }}
    />
    <path
      d="M89.21 132.11H64.24c-35.05 0-63.52-28-64.17-62.74v134.35c0 38.93 31.73 70.54 70.82 70.54h70.52V132.11h-52.2Z"
      style={{ fill: '#2d75ff' }}
    />
    <path d="M266.2 132.11H141.35v142.15H266.2V132.11Z" style={{ fill: '#f78cfe' }} />
    <path
      d="M336.3 132.11h-70.52v142.15h77.1c35.41 0 64.12 28.6 64.23 63.87V202.66c0-38.93-31.73-70.54-70.82-70.54Z"
      style={{ fill: '#ff6e7b' }}
    />
  </svg>
)
